import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Text from 'components/shared/Text';
import ButtonText from 'components/shared/ButtonText';
import Spinner from 'components/shared/Spinner';
import styles from './styles.module.scss';

function Card(props) {
  const { t } = useTranslation();
  const renderContents = () => {
    if (props.loading) {
      return (
        <div className={styles.centered}>
          <Spinner delayed />
        </div>
      );
    }
    if (props.error) {
      return (
        <div className={styles.centered}>
          <Text>{t('error_title_generic')}</Text>
          <ButtonText underlined onClick={props.errorRefetch}>
            {t('common_try_again')}
          </ButtonText>
        </div>
      );
    }
    return (
      <div className={classnames([styles.content, ...props.contentWrapperStyles])}>{props.children}</div>
    );
  };

  if (props.isMobile) return renderContents();
  return (
    <div className={classnames([styles.card, ...props.cardStyles])}>
      {props.customHeader && props.customHeader}
      {!props.customHeader && (
        <div className={classnames([styles.header, ...props.headerStyles])}>
          {props.title}
          {props.headerComponent && props.headerComponent}
        </div>
      )}
      {renderContents()}
    </div>
  );
}

/* eslint-disable react/no-unused-prop-types */
Card.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorRefetch: PropTypes.func,
  title: PropTypes.string,
  headerComponent: PropTypes.element,
  customHeader: PropTypes.element,
  children: PropTypes.any,
  // contentPadding,
  // headerPadding,
  // headerHeight,
  cardStyles: PropTypes.array,
  headerStyles: PropTypes.array,
  contentWrapperStyles: PropTypes.array,
  isMobile: PropTypes.bool
};

Card.defaultProps = {
  loading: false,
  error: false,
  errorRefetch: () => {},
  title: '',
  headerComponent: null,
  customHeader: null,
  children: null,
  // headerHeight: '40px',
  cardStyles: [],
  headerStyles: [],
  contentWrapperStyles: [],
  isMobile: false
};

export default Card;
